var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gs-card',{staticClass:"gs-analytics-error"},[_c('h2',{staticClass:"gs-analytics-error__title"},[_vm._v("Analytics could not be loaded")]),_c('p',{staticClass:"gs-analytics-error__copy"},[_vm._v(_vm._s(_vm.message))]),_c('gs-button',{attrs:{"variant":"outline"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v("Try again")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }